import { Injectable } from '@angular/core';

import { GridController, TSortDirections } from '../../classes/grid-page-info';
import { FilterItems } from '../../components/filters/filter.interface';
import { EraFilters, IEra } from '../../interfaces/era/era.interface';

@Injectable({
  providedIn: 'root',
})
export class EraStateService extends GridController<EraFilters> {
  private _eras: IEra[];

  private _filter: EraFilters = {
    dateFrom: '',
    dateTo: '',
    groupId: '',
    billingNpi: '',
    billingTaxId: '',
    payerId: '',
    payerName: '',
    submitterId: '',
    eraDate: 'effectiveDate',
    paymentAmount: '',
    traceNumber: '',
    inputFilename: '',
    outputFilename: '',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    status: '' as any,
  };

  eraFilters: FilterItems = {
    filtersName: 'Eras',
    items: [
      {
        name: 'dateRange',
        type: 'dateRangeCalendarInline',
        dateFromControlName: 'dateFrom',
        dateToControlName: 'dateTo',
        class: 'dates',
      },
      {
        caption: 'ERA date',
        name: 'eraDate',
        placeholder: 'Select ERA Date',
        type: 'horizontalSwitch',
        values: [
          { text: 'Check Date', value: 'effectiveDate' },
          { text: 'Received Date', value: 'dateReceived' },
        ],
        class: 'datesType',
      },
      {
        name: 'groupId',
        caption: 'group Id',
        type: 'text',
        placeholder: 'Enter Group',
        queryOperator: 'eq',
        class: 'groupId',
      },
      {
        caption: 'NPI',
        name: 'billingNpi',
        type: 'text',
        placeholder: 'Enter NPI',
        queryOperator: 'eq',
        class: 'billingNpi',
      },
      {
        caption: 'Tax ID',
        name: 'billingTaxId',
        type: 'text',
        placeholder: 'Enter Tax ID',
        queryOperator: 'eq',
        class: 'billingTaxId',
      },
      {
        caption: 'payer id',
        name: 'payerId',
        type: 'text',
        placeholder: 'Enter Payer ID',
        queryOperator: 'eq',
        class: 'payerId',
      },
      {
        caption: 'payer Name',
        name: 'payerName',
        type: 'text',
        placeholder: 'Enter Payer Name',
        class: 'payerName',
        //queryOperator: 'eq'
      },
      {
        caption: 'SUBMITTER ID',
        name: 'submitterId',
        type: 'text',
        placeholder: 'Enter Submitter ID',
        queryOperator: 'eq',
        class: 'submitterId',
      },
      {
        caption: 'amount',
        name: 'paymentAmount',
        type: 'number',
        placeholder: 'Enter Amount',
        queryOperator: 'eq',
        class: 'paymentAmount',
      },
      {
        caption: 'Check Number',
        name: 'traceNumber',
        type: 'text',
        placeholder: 'Enter Check Number',
        class: 'traceNumber',
        configQueryOperators: ['startsWith', 'contains'],
        queryOperator: 'eq',
      },
      {
        caption: 'Input File Name',
        name: 'inputFilename',
        type: 'text',
        placeholder: 'Enter Input File name',
        configQueryOperators: ['startsWith', 'contains'],
        queryOperator: 'eq',
        class: 'inputFilename',
      },
      {
        caption: 'Output File Name',
        name: 'outputFilename',
        type: 'text',
        placeholder: 'Enter Output File Name',
        configQueryOperators: ['startsWith', 'contains'],
        queryOperator: 'eq',
        class: 'outputFilename',
      },
      {
        caption: 'Status',
        name: 'status',
        type: 'select',
        placeholder: 'Select Era Status',
        values: [
          { value: 'Duplicate', key: 'DUPLICATE' },
          { value: 'Waiting', key: 'WAITING' },
          { value: 'Complete', key: 'COMPLETE' },
          { value: 'Held', key: 'HELD' },
          { value: 'Missing', key: 'MISSING' },
        ],
        queryOperator: 'eq',
        class: 'status',
      },
    ],
  };

  override _sortDirections: TSortDirections = {
    groupId: '',
    dateReceived: '',
    traceNumber: '',
    submitterId: '',
    billingNpi: '',
    billingTaxId: '',
    payerId: '',
    payerName: '',
    paymentAmount: '',
    inputFilename: '',
    outputFilename: '',
    status: '',
    transmissionDate: '',
  };

  constructor() {
    super();
    this.init(this._filter, 1, 'payerTaxId');
  }

  get eras(): IEra[] {
    return this._eras;
  }

  set eras(value: IEra[]) {
    this._eras = value;
  }
}
